import { styled } from '@abyss/web/tools/styled';
import { Button } from '@abyss/web/ui/Button';
import { Heading } from '@abyss/web/ui/Heading';
import { Layout } from '@abyss/web/ui/Layout';

export const StyledConfirmPCPHeading = styled(Heading, {
  margin: '16px 0 8px 0',
});

export const StyledConfirmPCPContainer = styled(Layout.Stack, {
  marginBottom: '-8px !important',
});

export const StyledNewPCPCard = styled('div', {
  backgroundColor: 'white',
  borderRadius: '12px',
  border: '1px solid $primary1',
  boxShadow: '0px 3px 6px 0px rgba(0, 0, 0, 0.15)',
  margin: '0 12px 8px 0',
  padding: '16px 24px 24px 24px',
  width: '407px',
  '@screen < $sm': {
    margin: '0 0 24px 0',
    width: '100%',
  },
});

export const StyledPreviousPCPCard = styled('div', {
  backgroundColor: '$gray1',
  borderRadius: '12px',
  margin: '0 0 8px 12px',
  padding: '16px 24px 24px 24px',
  width: '407px',
  '@screen < $sm': {
    margin: '0 0 0 0',
    width: '100%',
  },
});

export const StyledConfirmPCPInfoHeading = styled(Heading, {
  '&.abyss-heading-root': {
    lineHeight: '24px',
    display: 'inline-block',
    fontSize: '18px',
  },
});

export const StyledConfirmPCPCardHeading = (phoneOnly: boolean) => ({
  '&.abyss-heading-root': {
    ...(phoneOnly
      ? {
          fontSize: '18px',
        }
      : {
          fontSize: '20px',
        }),
  },
});

export const StyledConfirmPCPInfo = styled('div', {
  backgroundColor: 'white',
  borderRadius: '12px',
  border: '1px solid $gray3',
  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.05)',
  padding: '12px',
});

export const StyledConfirmButton = styled(Button, {
  '&.abyss-button-content-container': {
    '>span': {
      '>span': {
        paddingLeft: '4px',
      },
    },
  },
});

export const StyledConfirmPCPNameCardText = styled('div', {
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
});

export const StyledConfirmPCPAddressCardText = styled('div', {
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
});

export const PCPLocationAlertHeaderCss = {
  'abyss-alert-root': {
    alignItems: 'flex-start',
    borderRadius: 'var(--alert-border-radius-all-container-inline, 8px)',
    border:
      'var(--alert-border-width-all-container-inline, 1px) solid var(--alert-color-border-container-info, #C3D8F2)',
    background: 'var(--alert-color-surface-container-info, #EEF4FF)',
  },
  'abyss-alert-wrapper': {
    gap: 'var(--alert-spacing-gap-horizontal-container-inline, 8px)',
  },
  'abyss-alert-title': {
    font: 'var(--web-semantic-font-family-h-sans, "UHC2020 Sans") !important',
    fontSize: 'var(--web-core-font-size-h-desktop-20, 18px) !important',
    fontStyle: 'normal !important',
    fontWeight: '700 !important',
    lineHeight: '120% !important' /* 21.6px */,
    letterSpacing: 'var(--web-core-letter-spacing-none, 0) !important',
    color: 'var(--alert-color-text-heading, #323334) !important',
  },
  'abyss-alert-body-text': {
    fontSize: 'var(--web-core-font-size-p-80, 16px) !important',
    fontWeight: '400 !important',
    font: 'var(--web-semantic-font-family-p, "UHC2020 Sans") !important',
    color: 'var(--alert-color-text-paragraph, #4B4D4F) !important',
    lineHeight: '140% !important',
    letterSpacing: 'var(--web-core-letter-spacing-none, 0) !important',
  },
  'abyss-alert-separator': {
    display: 'none !important',
  },
  'abyss-alert-close-button': {
    alignSelf: 'flex-start',
  },
};
